export default {
  common: {
    name: 'Nom',
    player: 'Joueur',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    unlogged: 'Vous devez être connecté pour accéder à cette partie du site.'
  },
  buttons: {
    disconnect: 'Déconnexion',
    close: 'Fermer',
    finish: 'Finir',
    login: 'Connexion',
    register: 'Créer un compte'
  },
  nav: {
    feed: 'Actualités',
    leaderboard: 'Classement',
    matchs: 'Matchs',
    tournaments: 'Tournois',
    rules: 'Règles',
    about: 'À propos',
    guild: 'Guilde',
    unlogged: 'Se connecter/S\'inscrire',
    logged: 'Mon compte',
    newMatchButton: 'Nouveau match'
  },
  banners: {
    feed: {
      title: {
        1: 'S o c i a l'
      },
      subtitle: {
        1: 'Quoi de neuf aujourd\'hui?'
      }
    },
    leaderboard: {
      title: {
        1: 'Regarde ton classement.',
        2: 'Est-ce que t\'es classé au moins..?'
      },
      subtitle: {
        1: 'Vas-tu battre tes amis aujourd\'hui?'
      }
    },
    home: {
      title: {
        1: 'Bienvenue !'
      },
      subtitle: {
        1: 'Des nouvelles fraiches'
      }
    },
    tournaments: {
      title: {
        1: 'Tournois'
      },
      subtitle: {
        1: 'Où les talents se dévoilent.',
        2: 'Devient le meilleur.'
      }
    },
    matchs: {
      title: {
        1: 'Matchs'
      },
      subtitle: {
        1: ''
      }
    },
    match: {
      title: {
        1: 'Match'
      },
      subtitle: {
        1: ''
      }
    },
    rules: {
      title: {
        1: 'Règles'
      },
      subtitle: {
        1: 'Comment je fais pour jouer?',
        2: 'Détails et standards du Gobelet-Pong'
      }
    },
    about: {
      title: {
        1: 'À propos'
      },
      subtitle: {
        1: 'Qui sommes-nous?'
      }
    },
    guild: {
      title: {
        1: 'Guilde'
      },
      subtitle: {
        1: 'Un pour tous !'
      }
    },
    logged: {
      title: {
        1: 'Vous êtes dans votre base.'
      },
      subtitle: {
        1: 'Tout va bien?'
      }
    }
  },
  pages: {
    loginRegister: {
      login: {
        title: 'Se connecter',
        subtitle: 'Renseignez vos identifiants pour vous connecter'
      },
      register: {
        title: 'S\'inscrire',
        subtitle: 'Toujours pas de compte? C\'est par ici!'
      }
    },
    rules: {
      content: {
        equipment: {
          title: 'Équipement',
          table: 'Une table de ping pong',
          paddle: 'Des raquettes',
          ball: 'Une balle',
          gob: '2 gobelets'
        },
        preparation: {
          title: 'Préparation du terrain',
          above: 'Vue de dessus',
          side: 'Vue de profil'
        },
        goal: {
          title: 'Le but',
          description: 'Faire tomber le gobelet adverse.'
        },
        rules: {
          title: 'Règles',
          unit: 'Une unité correspond au diamètre de la base d\'un gobelet.',
          points: {
            standard: {
              presentation: 'Un point "standard" est un point normal de ping-pong.',
              effect: 'Lorsqu\'un point standard est perdu, le gobelet recule d\'une unité.'
            },
            slide: {
              presentation: 'Un "slide" se produit lorsque le gobelet touché, glisse sur la table.',
              effect: 'Lors d\'un slide, replacer le gobelet sur la ligne centrale en comptabilisant les unités perdues.'
            }
          },
          statusquo: {
            presentation: 'Un "Status-quo" se produit lorsque la balle touche le gobelet, sans le faire bouger.',
            effect: {
              first: 'Lors d\'un Status-quo, replacer le gobelet sur son unité. ',
              second: 'Aucun point n\'est comptabilisé. Cependant, si le prochain point perdu est standard, le gobelet perdant reculera de deux unités, au lieu d\'une. '
            }
          },
          bdg: 'Lorsque le gobelet est au bord de la table, il y a "Bord du gouffre". Le prochain point standard est décisif.',
          preparation: {
            title: 'Avant le match',
            first: 'Avant de commencer un match, les joueurs échangent 3 points standards.',
            second: 'Celui qui l\'emporte gagne le premier service.'
          },
          services: {
            title: 'Les services',
            first: 'Les services s\'alternent à chaque tour.',
            second: 'Lorsqu\'un joueur rate son service, son gobelet recule d\'une unité.',
            third: 'Un gobelet touché au service n\'est pas comptabilisé (afin d\'éviter que les joueurs se préparent à viser). Le service est à refaire. Si cette situation se présente 3 fois d\'affilées, le service est considéré comme raté.'
          },
          gameplay: {
            title: 'Avantages du gameplay',
            neverTooLate: 'Une partie n’est pas finie tant que le gobelet n’est pas tombé, c’est à dire que même en mauvaise posture, en visant correctement, la partie peut entièrement se retourner.',
            strategy: 'La stratégie est très présente. Puisque les joueurs peuvent décider de marquer un point classique ou de viser le gobelet afin de le toucher. Le fait de devoir viser fait se concentrer le joueur sur cet objectif et n’essaye plus simplement de marquer un point.',
            levels: 'Les matchs sont moins cloisonnés par niveau et permettent la rencontre d’une palette plus large de joueurs grâce au système de visée.'
          }
        }
      }
    },
    about: {
      content: {
        welcome: 'Bienvenue !',
        presentation: 'Nous avons créé ce site pour faire découvrir au monde le Gobelet-pong et permettre à ses utilisateurs de profiter pleinement de l\'expérience.',
        founders: {
          alexis: 'Aucun de ces 2 là ne peut contrer mes techniques.',
          thomas: 'Champion Intercontinental de Gobelet Pong, sur le campus de Tours uniquement.',
          victor: 'Je perds toujours en finale :('
        }
      }
    }
  },
  events: {
    title: 'Évènements',
    nothing: 'Aucun évènement prévu.'
  },
  footer: {
    slogan: 'Le Gobelet-Pong est un sport.',
    data: 'Nous ne stockons aucune donnée personnelle',
    contact: 'Pour toutes questions, contactez'
  }
}



// WEBPACK FOOTER //
// ./src/lang/fr.js